import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import usePromoDisplay from '~/shared/utils/usePromoDisplay';
import {
  ProductPrice,
  useProductContext,
} from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

import { promoPriceHiddenPromoTypes } from '../../constants/products';

const DynamicFormattedMessage = FormattedMessage;

const Wrapper = styled.span``;

const PromoMessageWrapper = styled.span`
  ${({ $promoMessageStyle }) => $promoMessageStyle}
`;

const defaultGetPromoCodeMessageId = (promoCode) => {
  return `site_pdp_callout.price_label_${promoCode}`;
};

function PromoMessage({
  'data-autotag': dataAutotag,
  product: productFromProps,
  promoPriceStyle,
  promoMessageStyle,
  showPromoPrice: showPromoPriceFromProps = true,
  getPromoCodeMessageId = defaultGetPromoCodeMessageId,
  ...rest
}) {
  const productFromCtx = useProductContext();
  const product = productFromProps || productFromCtx;

  const promoTypeId = product?.promos?.promoTypeId;
  const showPromoPrice = showPromoPriceFromProps
    ? !promoPriceHiddenPromoTypes.has(promoTypeId)
    : undefined;

  const {
    hasPromo,
    isPrioritizedEnabled,
    shouldShowOfferLabel,
    shouldShowPromoLabel,
    offerLabel,
    promoLabel,
    promoCode,
  } = usePromoDisplay({ product });

  const hasColon = promoLabel?.trim().endsWith(':');

  if (!hasPromo && !isPrioritizedEnabled) {
    return null;
  }

  return (
    <Wrapper tabIndex={0} {...rest}>
      <PromoMessageWrapper
        $promoMessageStyle={promoMessageStyle}
        data-autotag={dataAutotag}
      >
        {shouldShowOfferLabel && (
          <span dangerouslySetInnerHTML={{ __html: `${offerLabel}` }} />
        )}
        {shouldShowPromoLabel && (
          <DynamicFormattedMessage
            id={defaultGetPromoCodeMessageId(promoCode)}
            defaultMessage={promoLabel}
          />
        )}
        {hasColon || !showPromoPrice ? null : ': '}
      </PromoMessageWrapper>
      {showPromoPrice && (
        <ProductPrice
          promoPriceStyle={promoPriceStyle}
          showPromoPrice
          showVipPrice={false}
          data-autotag="pdp-promo-price"
        />
      )}
    </Wrapper>
  );
}

PromoMessage.propTypes = {
  'data-autotag': PropTypes.string,
  getPromoCodeMessageId: PropTypes.func,
  product: PropTypes.object,
  promoMessageStyle: PropTypes.any,
  promoPriceStyle: PropTypes.any,
  showPromoPrice: PropTypes.bool,
};

export default PromoMessage;
